module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Fifty-Shades-Freed.84a39b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Fifty-Shades-Freed.jpg
// module id = EBvX
// module chunks = 0